// 导入封装的方法
import {
  post
} from '../http'

const livingRoom = {
  officeonlinetopic: {
    list (params) {
      return post('/officeonlinetopic/list', params)
    },
    info (params) {
      return post('/officeonlinetopic/info/' + params)
    },
    add (params) {
      return post('/officeonlinetopic/add', params)
    },
    del (params) {
      return post('/officeonlinetopic/del/' + params)
    },
    dels (params) {
      return post('/officeonlinetopic/dels', params)
    },
    edit (params) {
      return post('/officeonlinetopic/edit', params)
    }
  },
  officeonlineletter: {
    list (params) {
      return post('/officeonlineletter/web/listPublic', params)
    },
    info (params) {
      return post('/officeonlineletter/web/info/' + params)
    },
    add (params) {
      return post('/officeonlineletter/addPublic', params)
    }
  }
}
export default livingRoom
